module.exports = __webpack_public_path__ + "icon-modify-dns.png?323480e8842783b4b53e660563166f74";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icon-modify-dns.png
// module id = 410
// module chunks = 0